import environment from "environment";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import EffectUtility from "../../utilities/EffectUtility";
import AssicurazioneModel from "./models/AssicurazioneModel";
import DettaglioCreditoNetModel from "./models/creditoNet/DettaglioCreditoNetModel";
import ProdottoLightModel from "./models/ProdottoLightModel";
import DettaglioRichiestaCedibilitaModel from "./models/richiestaCedibilita/DettaglioRichiestaCedibilitaModel";
import RichiestaOtpModel from "./models/RichiestaOtpModel";
import SimulazioneCreditoNetTableModel from "./models/SimulazioneCreditoNetTableModel";
import SimulazioneLightModel from "./models/SimulazioneLightModel";
import SimulazioneModel from "./models/SimulazioneModel";
import SimulazioneRichiestaCedibilitaTableModel from "./models/SimulazioneRichiestaCedibilitaTableModel";
import TaegTegModel from "./models/TaegTegModel";
import TassiModel from "./models/TassiModel";
import ValoriModel from "./models/ValoriModel";
import VersionSpendingReviewModel from "./models/VersionSpendingReviewModel";
import { number } from "yup";
import MailCertificataModel from "./models/MailCertificataModel";

export interface ISimulateRequest {
    idProduct: number;
    idRequestedType: number;
    idChannel: number;
    idSegment: number;
    idAdministrativeCategory: number;
    instalment: number;
    duration: number;
    idAgent?: number;
    birthDate: string;
    hiringDate?: string;
    effectiveDate?: string;
    amount: number;
    idConvention?: number;
    // salary?: number;
    simulationRequestType: number;
    insuranceTuple?: AssicurazioneModel;
    idSubLevel?: number;
    idPracticeType?: number;
    dataRinnovoCq?: string;
    rataRinnovoCq?: number;
    mesiRinnovoCq?: string;
    segnalazione?: string;
    dipendenteBanca?: boolean;
    idDipendenteSub?: number;
}

export interface IAssicurazioniGetRequest {
    idProduct: number;
    idRequestedType: number;
    idSegment: number;
    idAdministration?: number | string;
    duration: number;
    birthDate: string;
    hiringDate?: string;
    startDate?: string;
    EffectiveDate?: string;
    requiredAmount: number;
    sesso?: string;
}

export interface ITaegTegRequest {
    tanBase: number;
    preliminaryCost: ValoriModel;
    reportingBankCommissions: ValoriModel;
    agentCommissions: ValoriModel;
    bankCommissions: ValoriModel;
    intermediationCosts: ValoriModel;
    cessionaryCommissions: ValoriModel;
    upFrontCommissions: ValoriModel;
    runningCommissions: ValoriModel;
    maxTotalCommissions: ValoriModel;
    charges: number;
    guid: string;
    wearRates?: TassiModel[];
}

export interface ISalvaSimulazioneRequest {
    idProduct: number;
    idConvention?: number;
    idSubLevel?: number;
    idPracticeType?: number;
    idMacroProduct: number;
    instalment: number;
    duration: number;
    birthDate: string;
    hiringDate?: string;
    amount: number;
    name: string;
    effectiveDate: string;
    guid?: string;
    editedData: {
        tanBase: number;
        preliminaryCost?: ValoriModel;
        reportingBankCommissions?: ValoriModel;
        bankCommissions?: ValoriModel;
        agentCommissions?: ValoriModel;
        charges: number;
        intermediationCosts?: ValoriModel;
        cessionaryCommissions?: ValoriModel;
        upFrontCommissions?: ValoriModel;
        runningCommissions?: ValoriModel;
        maxTotalCommissions: ValoriModel;
        wearRates: TassiModel[];
        preloadedCommissions?: ValoriModel;
    };
    idInsuranceLifeRisk: number;
    idInsuranceCreditRisk: number;
    idPriceListLifeRisk: number;
    idPriceListCreditRisk: number;
    interestAmount: number;
    irr: number;
    taeg: number;
    teg: number;
    stampDuty: number;
    vaCapital: number;
    balance: number;
    idRequestedType: number;
    idChannel: number;
    idSegment: number;
    idAdministrativeCategory: number;
    idAgent?: number;
    idAdministration?: number;
    unregisteredAtcName?: string;
    idSimulation?: number;
    salary: number;
    tan: number;
    idIntegration?: number;
    serviceGuid?: string;
    insuranceTuple?: AssicurazioneModel;
    dataRinnovoCq?: string;
    rataRinnovoCq?: number;
    mesiRinnovoCq?: string;
    idDipendenteSub?: number;
    segnalazione?: string;
    dipendenteBanca?: boolean;
    idMotivCambioTan?: number;
}

export interface IRicalcolaRequest {
    idProduct: number;
    idMacroProduct: number;
    idRequestedType: number;
    idChannel: number;
    idSegment: number;
    idConvention?: number;
    idSubLevel?: number;
    idPracticeType?: number;
    idAdministrativeCategory: number;
    idAgent?: number;
    instalment: number;
    duration: number;
    birthDate: string;
    hiringDate?: string;
    amount: number;
    guid?: string;
    salary: number;
    effectiveDate?: string;
    insuranceTuple?: AssicurazioneModel;
    editedData: {
        // tan: number;
        preliminaryCost?: ValoriModel;
        reportingBankCommissions?: ValoriModel;
        bankCommissions?: ValoriModel;
        agentCommissions?: ValoriModel;
        charges: number;
        intermediationCosts?: ValoriModel;
        cessionaryCommissions?: ValoriModel;
        upFrontCommissions?: ValoriModel;
        runningCommissions?: ValoriModel;
        preloadedCommissions?: ValoriModel;
        maxTotalCommissions: ValoriModel;
        wearRates: TassiModel[];
        tanBase: number;
    };
    dataRinnovoCq?: string;
    rataRinnovoCq?: number;
    mesiRinnovoCq?: string;
    segnalazione?: string;
    dipendenteBanca?: boolean;
    idMotivCambioTan?: number;
    idDipendenteSub?: number;
}

export interface ICreditoNetRequest {
    date: string;
    taxCode: string;
    monthSalary: string;
    idSalary: string;
    withholdingCode: string;
    agencyCode: string;
    guid: string;
}

export interface IRichiestaCedibilitaRequest {
    date: string;
    taxCode: string;
    agencyCode: string;
    pensionCategoryCode: string;
    pensionCertificateNumber: string;
    documentType: string;
    documentNumber: string;
    authorityCode: number;
    privacy: boolean;
    guid: string;
}

export interface IRichiestaOtpRequest {
    taxCode: string;
    agencyCode: string;
}

export interface IRichiestaVerificaOtpRequest {
    ente: number;
    codFiscale: string;
    chiavePensione: string;
    numDocumento: string;
    tipoDocumento: string;
    nettaAOI: string;
    codiceOTP: string;
    importoPensione: string;
    agencyCode: string;
    guid: string;
}

export default class SimulazioneEffect {
    public static async simulazioniGet(total: number): Promise<SimulazioneLightModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniGet;
        return EffectUtility.getToModel<SimulazioneLightModel[]>(SimulazioneLightModel, endpoint, {
            TotSimulation: total,
        });
    }

    public static async simulate(request: ISimulateRequest): Promise<SimulazioneModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulate;
        return EffectUtility.postToModel<SimulazioneModel>(SimulazioneModel, endpoint, request);
    }

    public static async prodottiLightGet(
        idRequestedType: number,
        idAdministrativeCategory: number,
        segment: string,
        importo: string,
        durata: string,
        eta: string,
        idAgent?: number,
        dipendenteBanca?: boolean,
        rata?: string
    ): Promise<ProdottoLightModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.lookupProdottiGet;
        return EffectUtility.postToModel<ProdottoLightModel[]>(ProdottoLightModel, endpoint, {
            idRequestedType: idRequestedType,
            idAdministrativeCategory: idAdministrativeCategory,
            segment: segment,
            idAgent: idAgent,
            eta: eta,
            importo: importo,
            durata: durata,
            dipendenteBanca: dipendenteBanca,
            rata: rata,
        });
    }

    public static async assicurazioniGet(
        request: IAssicurazioniGetRequest
    ): Promise<AssicurazioneModel[] | HttpErrorResponseModel> {
        const endpoint: string = environment.api.assicurazioniGet;
        return EffectUtility.postToModel<AssicurazioneModel[]>(AssicurazioneModel, endpoint, request);
    }

    public static async calculateTaegTeg(request: ITaegTegRequest): Promise<TaegTegModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.calculateTaegTeg;
        return EffectUtility.postToModel<TaegTegModel>(TaegTegModel, endpoint, request);
    }

    public static async salva(request: ISalvaSimulazioneRequest): Promise<SimulazioneModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.salvaSimulazione;
        return EffectUtility.postToModel<SimulazioneModel>(SimulazioneModel, endpoint, request);
    }

    public static async update(request: ISalvaSimulazioneRequest): Promise<SimulazioneModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.salvaSimulazione;
        return EffectUtility.patchToModel<SimulazioneModel>(SimulazioneModel, endpoint, request);
    }

    public static async ricalcola(request: IRicalcolaRequest): Promise<SimulazioneModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.ricalcolaSimulazione;
        return EffectUtility.postToModel<SimulazioneModel>(SimulazioneModel, endpoint, request);
    }

    public static async creditoNetGet(
        request: ICreditoNetRequest
    ): Promise<SimulazioneCreditoNetTableModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniCreditoNetGet;
        return EffectUtility.postToModel<SimulazioneCreditoNetTableModel>(
            SimulazioneCreditoNetTableModel,
            endpoint,
            request
        );
    }

    public static async dettaglioCreditoNetGet(id: number): Promise<DettaglioCreditoNetModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniCreditoNetDettaglioGet + `?id=${id}`;
        return EffectUtility.postToModel<DettaglioCreditoNetModel>(DettaglioCreditoNetModel, endpoint);
    }

    public static async richiestaCedibilitaGet(
        request: IRichiestaCedibilitaRequest
    ): Promise<SimulazioneRichiestaCedibilitaTableModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniRichiestaCedibilitaGet;
        return EffectUtility.postToModel<SimulazioneRichiestaCedibilitaTableModel>(
            SimulazioneRichiestaCedibilitaTableModel,
            endpoint,
            request
        );
    }

    public static async richiestaOtpInvia(
        request: IRichiestaOtpRequest
    ): Promise<RichiestaOtpModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniRichiestaCedibilitaOtpInvia;
        return EffectUtility.postToModel<RichiestaOtpModel>(RichiestaOtpModel, endpoint, request);
    }

    public static async richiestaVerificaOtpInvia(
        request: IRichiestaVerificaOtpRequest
    ): Promise<SimulazioneRichiestaCedibilitaTableModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniRichiestaCedibilitaVerificaOtp;
        return EffectUtility.postToModel<SimulazioneRichiestaCedibilitaTableModel>(
            SimulazioneRichiestaCedibilitaTableModel,
            endpoint,
            request
        );
    }

    public static async dettaglioRichiestaCedibilitaGet(
        id: number
    ): Promise<DettaglioRichiestaCedibilitaModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.simulazioniRichiestaCedibilitaDetaglioGet + `?id=${id}`;
        return EffectUtility.postToModel<DettaglioRichiestaCedibilitaModel>(
            DettaglioRichiestaCedibilitaModel,
            endpoint
        );
    }

    public static async resumeSimulation(idSimulation: number): Promise<SimulazioneModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.resumeSimulation;
        return EffectUtility.getToModel<SimulazioneModel>(SimulazioneModel, endpoint, {
            idSimulation: idSimulation,
        });
    }

    public static async getSpendingReview(): Promise<VersionSpendingReviewModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.configSpendingReview;
        return EffectUtility.getToModel<VersionSpendingReviewModel>(VersionSpendingReviewModel, endpoint);
    }

    public static async setCertificaMail(email: string): Promise<Number | HttpErrorResponseModel> {
        const endpoint: string = environment.api.certificaEmail;
        return EffectUtility.getToModel<Number>(null, endpoint, {
            email: email,
        });
    }

    public static async setValidaMail(
        email: string,
        idCertificazione: Number,
        otp: string,
        IdSimulation: number
    ): Promise<boolean | HttpErrorResponseModel> {
        const endpoint: string = environment.api.validaEmail;
        return EffectUtility.getToModel<boolean>(null, endpoint, {
            email: email,
            idCertificazione: idCertificazione,
            otp: otp,
            IdSimulation: IdSimulation,
        });
    }

    public static async resumeCertificateMail(
        email: string,
        idCertificazione: Number
    ): Promise<MailCertificataModel | HttpErrorResponseModel> {
        const endpoint: string = environment.api.recuperaCertificazioneEmail;
        return EffectUtility.getToModel<MailCertificataModel>(null, endpoint, {
            email: email,
            idCertificazione: idCertificazione,
        });
    }
}
